import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type DashboardNamePosition = 'top' | 'below';

export interface DashboardTitleState {
  title: string;
  position: DashboardNamePosition;
  fontSize: string;
}

@Injectable({ providedIn: 'root' })
export class DashboardTitleService {
  private readonly stateSubject = new BehaviorSubject<DashboardTitleState>({
    title: '',
    position: 'below',
    fontSize: '',
  });

  readonly state$ = this.stateSubject.asObservable();

  setDashboardTitle(title: string, position: DashboardNamePosition = 'below', fontSize = ''): void {
    this.stateSubject.next({
      title: String(title || '').trim(),
      position,
      fontSize: String(fontSize || '').trim(),
    });
  }

  clearDashboardTitle(): void {
    this.stateSubject.next({
      title: '',
      position: 'below',
      fontSize: '',
    });
  }
}
